// @flow

export const ALERT_SHOW = "ALERT_SHOW";
export const ALERT_HIDE = "ALERT_HIDE";

export function alertShow(type: string, icon: string, title: string, text: ?string) {
  return {
    type: ALERT_SHOW,
    alertType: type,
    icon,
    title,
    text
  };
}

export function alertHide() {
  return { type: ALERT_HIDE };
}
